
import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';
import Peripherals from '@appblocks/codegeneration/Peripherals';
import {
    CodeBlock, BlockType, SettingType, Setting, SettingState, TibboDataType,
    SettingOption,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import * as micropython from './micropython';
import * as zephyr from './zephyr';
import * as simulator from './simulator';

export default class Servo extends BasePeripheral {
    constructor() {
        super();
        this.id = 'servo';
        this.name = 'Servo Motor';
        this.requirements = [['zephyr', 'micropython']];
        const settings: Array<Setting> = [
            {
                id: 'PIN',
                name: 'PIN',
                settingType: SettingType.PIN,
                meta: 'GPIO',
                required: true,
                default: '',
            },
            {
                id: 'PORT',
                name: 'Port',
                settingType: SettingType.OPTION,
                required: true,
                default: '',
            },
            {
                id: 'SERVO_PERIOD',
                name: 'PWM Period (microseconds)',
                settingType: SettingType.NAME,
                dataType: TibboDataType.INTEGER,
                required: true,
                default: 'SERVO_PERIOD',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingOptions(settingId: string): SettingOption[] | undefined {
        if (settingId === 'PORT') {
            const options = [];
            const device = PlatformUtils.getDeviceDefinition(this.project.device.id);
            for (let i = 0; i < device.peripherals.length; i++) {
                if (device.peripherals[i].type === 'pwm') {
                    options.push({
                        name: device.peripherals[i].id,
                        value: device.peripherals[i].settings.PORT.value,
                    });
                }
            }
            return options;
        }
        return super.getSettingOptions(settingId);
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'simulator':
                return simulator.getCodeBlocks(this);
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            default:
                return [];
        }
    }
}
